export enum ParentPage {
  Explorer = "explorer",
  NewProject = "new-project",
}
